export default __webpack_public_path__ + "static/media/create-campaigns-3.531b7ecb.png";